import { getTruckTypeList } from "modules/clientProjects/api";
import { useEffect, useState } from "react";
import isInList from "utils/isInList";

export default function useTruckTypes(truckInputValue) {
    const [trucks, setTrucks] = useState([]);

    useEffect(() => {
        const fetchAllTrucksTypes = async () => {
            try {
                const response = await getTruckTypeList(truckInputValue);
                setTrucks(Object.values(response.entities.truckTypes || []));
            } catch (error) {
                console.error(error);
            }
        };
        if (!isInList(trucks, truckInputValue, "attributes.alias")) {
            fetchAllTrucksTypes();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [truckInputValue]);

    return trucks;
}
